import { useEffect, useRef, useState } from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
} from "@mui/material";

import { ScrollableTable } from "../../templates/ScrollableTable";
import { LogRow } from "./LogRow";
import { useWindowResize } from "../../../hooks/useWindowResize";
import { CleaningEventItem } from "types/response/cleaningEvent";
import { CleaningMapItem } from "types/response/map";
import { CleaningRobotItem } from "types/response/robot";

export interface LogTableProps {
  logs: CleaningEventItem[];
  refetchFunc?: () => Promise<any>;
  enableRobotName?: boolean;
  robots?: CleaningRobotItem[];
  enableMapName?: boolean;
  maps?: CleaningMapItem[];
  enableMenu?: boolean;
  displayLimit?: number;
}

const LogTable = (props: LogTableProps) => {
  const {
    logs,
    refetchFunc,
    enableRobotName,
    robots = [],
    enableMapName,
    maps = [],
    enableMenu,
    displayLimit,
  } = props;
  const tableWrapperRef = useRef<HTMLDivElement>(null);
  const [tableWrapperRefWidth, setTableWrapperRefWidth] = useState(0);
  const [maxValues, setMaxValues] =  useState<{ [mapId: string]: number }>({});
  const width = useWindowResize();

  useEffect(() => {
    if (!tableWrapperRef.current) return;

    setTableWrapperRefWidth(
      tableWrapperRef.current.getBoundingClientRect().width
    );
  }, [width, tableWrapperRef]);

  useEffect(() => {
    const calculatedMaxValues = logs.reduce((acc, log) => {
      if (!acc[log.mapId] || log.cleaningArea > acc[log.mapId]) {
        acc[log.mapId] = log.cleaningArea;
      }
      return acc;
    }, {} as { [mapId: string]: number });

    setMaxValues(calculatedMaxValues);
  }, [logs]);

  const displayLogs = displayLimit ? logs.slice(0, displayLimit) : logs;
  
  return (
    <Box ref={tableWrapperRef}>
      <ScrollableTable component={Paper}>
        <Table aria-label="simple table" sx={{ whiteSpace: "nowrap" }}>
          <TableHead>
            <TableRow>
              <TableCell>{/* アイコン用 */}</TableCell>
              {enableRobotName && (
                <TableCell sx={{ minWidth: "120px" }}>清掃ロボット</TableCell>
              )}
              {enableMapName && (
                <TableCell sx={{ minWidth: "120px" }}>マップ</TableCell>
              )}
              <TableCell>清掃開始時間</TableCell>
              <TableCell>清掃終了時間</TableCell>
              <TableCell>稼働時間</TableCell>
              <TableCell sx={{ minWidth: "100px" }}>ステータス</TableCell>
              <TableCell>清掃面積</TableCell>
              <TableCell>進捗率</TableCell>
              {enableMenu && <TableCell>{/* メニュー用 */}</TableCell>}
            </TableRow>
          </TableHead>

          <TableBody>
            {displayLogs.length === 0 ? (
              <TableRow>
                <TableCell>
                  <Typography sx={{ p: 2 }}>ログがありません。</Typography>
                </TableCell>
              </TableRow>
            ) : (
              displayLogs.map((l) => {
                return (
                  <LogRow
                    key={l.cleaningEventId}
                    log={l}
                    refetchFunc={refetchFunc}
                    robots={robots}
                    maps={maps}
                    enableRobotName={enableRobotName}
                    enableMapName={enableMapName}
                    wrapperWidth={tableWrapperRefWidth}
                    maxCleaningArea={maxValues[l.mapId]}
                    enableMenu={enableMenu}                 />
                );
              })
            )}
          </TableBody>
        </Table>
      </ScrollableTable>
    </Box>
  );
};

export default LogTable;
